import routeReplaceSelf from '@/utils/routeReplaceSelf';

const custGoodsManage = {
    path: 'custGoodsManage',
    name: 'custGoodsManage',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'orgCdi',
        icon: 'HSIconfont hs-icon-goods',
        showRealm: ['SYSTEM', 'ADMIN']
    },
    children: [
        {
            path: 'custGoodsInfo',
            name: 'custGoodsInfo',
            component: routeReplaceSelf(() => import('@/views/custGoodsInfo')),
            meta: { code: 'orgCdi:organizationGoods' },
            children: [
                {
                    path: 'custGoodDetail',
                    name: 'custGoodDetail',
                    hidden: true,
                    component: () => import('@/views/custGoodDetail'),
                    meta: {
                        code: 'orgCdi_organizationGoods_retrieveStoreGoods',
                        activeMenu: 'custGoodsInfo',
                    },
                }
            ]

        }
    ]
};
export default custGoodsManage;